import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, AlertTriangle } from 'lucide-react';

const ContactSection = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="mb-4">
            <span className="text-[#548B2E] font-semibold tracking-[0.3em] uppercase text-sm [word-spacing:0.6em]">
              CONTACT US
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-6 leading-tight tracking-wide">
            Get in Touch
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">

          <div className="bg-white rounded-lg shadow-lg p-6 border border-orange-200">
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-orange-100 mb-4">
              <AlertTriangle className="w-8 h-8 text-orange-500" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Have an Issue?</h3>
            <p className="text-gray-600 text-sm mb-4">
              Placed a guest order? Raise a complaint and our team will resolve it promptly.
            </p>
            <Link
              to="/complaints/guest"
              className="inline-block w-full text-center bg-orange-500 hover:bg-orange-600 text-white font-semibold px-4 py-2 rounded-md transition-colors duration-300"
            >
              Raise a Complaint
            </Link>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-[#f2f8eb] mb-4">
              <Phone className="w-8 h-8 text-[#548B2E]" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Call Us</h3>
            <a href="tel:+918078622096" className="text-gray-600 hover:text-[#548B2E] transition-colors">
              +91-8078622096
            </a>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-[#f2f8eb] mb-4">
              <Mail className="w-8 h-8 text-[#548B2E]" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Grievance Officer</h3>
            <p className="text-xs text-gray-400 mb-1">For complaints &amp; privacy queries</p>
            <a href="mailto:grievances@bookmyfresh.com" className="text-gray-600 hover:text-[#548B2E] transition-colors">
              grievances@bookmyfresh.com
            </a>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactSection;
